import React, { Component } from 'react'

import './box.scss'

class Box extends Component {
  constructor (props) {
    super(props)
    this.state = {

    }
  }

  getStyle () {
    return `element-box ${this.getColor()}`
  }

  getColor () {
    const color = this.props.color

    switch (color) {
      case 'orange':
        return 'orange'
      case 'green':
        return 'green'
      case 'blue':
        return 'blue'
      case null:
      case undefined:
      case 'red':
      default:
        return 'red'
    }
  }

  render () {
    return (
      <div className={this.getStyle()}>
        {this.props.children}
      </div>
    )
  }
}

Box.defaultProps = {
  color: 'red' // colors: 'red', 'green', 'orange', 'blue'
}

export default Box



// WEBPACK FOOTER //
// ./src/app/shared/elements/box/index.js